import { render } from "./sensor.vue?vue&type=template&id=0bb7064e&scoped=true"
import script from "./sensor.vue?vue&type=script&lang=js"
export * from "./sensor.vue?vue&type=script&lang=js"

import "./sensor.vue?vue&type=style&index=0&id=0bb7064e&scoped=true&lang=css"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb7064e"]])

export default __exports__